import { createFileRoute } from '@tanstack/react-router'

import { TermsRoute } from '@/pages/legal/route-entries/terms-of-service'
import { buildPageTitle } from '@/utils/seo'

export const Route = createFileRoute('/_layout/terms-of-service')({
  component: TermsRoute,
  head: () => {
    return {
      meta: [
        {
          title: buildPageTitle('Terms of Service'),
        },
      ],
    }
  },
})
